import axios from 'axios';
import React, { Component } from 'react'
import { ApiUrl } from '../services/ApiRest';
import Cookies from 'universal-cookie';
import {
    NavLink as Link,
    withRouter
} from 'react-router-dom';

const cookie = new Cookies();
const urlAdministrativo = ApiUrl + "admins/";
const idAdministrativo = cookie.get("idAdministrativo");
const urlPeriodosCreditosExtra = ApiUrl + "periodos-creditos-extra-docente" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";

class SidebarDocente extends Component {
    componentDidMount() {
        // Get que devuelve los datos de un estudiante recibiendo un id
        axios.get(urlAdministrativo + idAdministrativo + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71")
            .then(res => {
                const estudiante = res.data;
                this.setState({ estudiante });
                //console.log(estudiante);

                cookie.set('nombres', estudiante.nombres_administrativo, { path: "/" })
                cookie.set('apellidos', estudiante.apellidos_administrativo, { path: "/" })

                // console.log(cookie.get("nombres"));
                // console.log(cookie.get("apellidos")); 
            })
        axios.get(urlPeriodosCreditosExtra, {
            params: {
                idDocente: cookie.get("idAdministrativo"),
            }
        })
            .then(response => {
                if (response.data.success !== true || response.data.data.length === 0) {
                    // Oculta el enlace si no hay periodos con créditos extra
                    const divCreditos = document.getElementById("divCreditosExtra");
                    if (divCreditos) divCreditos.style.display = "none";
                }
            })
            .catch(error => {
                console.error("Error consultando créditos extra:", error);
                const divCreditos = document.getElementById("divCreditosExtra");
                if (divCreditos) divCreditos.style.display = "none";
            });
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            document.body.classList.remove("sb-sidenav-toggled");
        }
    }
    render() {
        return (
            <div id="layoutSidenav_nav" style={{ width: 226 }}>
                <nav
                    className="sb-sidenav sb-sidenav-dark-custom accordion animate__animated animate__fadeInLeft"
                    id="sidenavAccordion"
                >
                    <div className="sb-sidenav-menu px-2 pt-3">
                        {/* Heading */}
                        <div className="sb-sidenav-menu-heading text-uppercase text-muted small mb-2">
                            <p className="text-white">Docente</p>
                        </div>

                        {/* Calificaciones Asignaturas*/}
                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseCalificaciones"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="far fa-user me-2"></i>
                                    Calificaciones
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapseCalificaciones">
                                <nav className="nav flex-column ms-3">
                                    <Link
                                        to="/docente/ListarAsignaturasDoc"
                                        className="nav-sub-link"
                                    >
                                        Asignaturas
                                    </Link>
                                    <Link
                                        to="/docente/ListarCreditosDoc"
                                        className="nav-sub-link"
                                        id="divCreditosExtra"
                                    >
                                        Créditos
                                    </Link>
                                </nav>
                            </div>
                        </div>

                        {/* Perfil */}
                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsePerfil"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="far fa-user me-2"></i>
                                    Perfil
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapsePerfil">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/docente/VerPerfilDocente" className="nav-sub-link">
                                        Ver Perfil
                                    </Link>
                                </nav>
                            </div>
                        </div>

                        {/* Titulación */}
                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseTitulacion"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="far fa-user me-2"></i>
                                    Titulación
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapseTitulacion">
                                <nav className="nav flex-column ms-3">
                                    <Link
                                        to="/docente/listarestudiantestitul"
                                        className="nav-sub-link"
                                    >
                                        Listar estudiantes asignados
                                    </Link>
                                </nav>
                            </div>
                        </div>

                        {/* Prácticas Preprofesionales */}
                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsePracticas"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="far fa-user me-2"></i>
                                    Prácticas Preprofesionales
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapsePracticas">
                                <nav className="nav flex-column ms-3">
                                    <Link
                                        to="/docente/ListarAsigTutPractLab"
                                        className="nav-sub-link"
                                    >
                                        Listar estudiantes asignados
                                    </Link>
                                </nav>
                            </div>
                        </div>
                    </div>

                    {/* Footer */}
                    <div className="sb-sidenav-footer text-white bg-azul-light text-center py-3 small">
                        Usuario:<br />
                        {cookie.get("nombres")} {cookie.get("apellidos")}
                    </div>
                </nav>
            </div>

        )
    }
}

export default withRouter(SidebarDocente);